import AdvancedController from "./advanced-controller";
import gsap from "gsap";
import { handleScroll } from "../bootstrap/setup-is-scrolled-detector";

const Config = {
  ANIMATION_DURATION: 0.75,
};

export default class PopupController extends AdvancedController {
  static values = {
    when: {
      type: String,
      default: "immediately",
    },
    openAfter: {
      type: Number,
      default: 0.25,
    },
  };

  static targets = [
    "popup"
  ];

  connect() {
    if (this.whenValue !== "immediately") {
      this.waitUntilScrolledToHalf()
    } else {
      this.pollCheckForBorlabsBeforeOpening();
    }
  }

  pollCheckForBorlabsBeforeOpening() {
    // schedule checks each second
    const intervalId = setInterval(() => {
      if (!document.body.classList.contains("borlabs-position-fix")) {
        clearInterval(intervalId);
        this.scheduleOpening();
      }    
    }, 1000);
  }

  scheduleOpening() {

    setTimeout(() => {
      this.open();
    }, this.openAfterValue * 1000);
  }

  open() {
    gsap.to(this.popupTarget, {
      opacity: 1,
      display: "flex",
      duration: Config.ANIMATION_DURATION,
    });
  }

  close(e) {
    e.preventDefault();

    const onComplete = () => {
      this.element.style.display = "none";
    };
    gsap.to(this.element, {
      opacity: 0,
      duration: Config.ANIMATION_DURATION,
      onComplete,
    });

    if (e.target.hasAttribute("href") && e.target.getAttribute("href") != "#") {
      location.href = e.target.getAttribute("href");
    }
  }

  waitUntilScrolledToHalf() {
    const body = document.body;
    const controller = new AbortController();
    let triggerPopup = false;

    const onScroll = () => {
      if (this.whenValue === "end") {
        const footer =  document.documentElement.querySelector("footer").getBoundingClientRect();
        if (document.documentElement.clientHeight >= footer.top) {
          triggerPopup = true;
        }
      } else {
        if (window.pageYOffset > body.scrollHeight * 0.33) {
          triggerPopup = true;
        }
      }

      if (triggerPopup) {
        controller.abort();
        this.pollCheckForBorlabsBeforeOpening();
      }
    };

    window.addEventListener('scroll', onScroll, { signal: controller.signal });
    onScroll();
  }
}
